module.exports = __webpack_public_path__ + "img/icon_USDCAD.26354b6e.png";